module.exports = __webpack_public_path__ + "static/media/12.db982374.jpg";